import ClassicEditorBuild from '@ckeditor/ckeditor5-build-classic';
import type { CKEditor } from '@ckeditor/ckeditor5-react';
import type { ComponentProps } from 'react';

type EditorProp = ComponentProps<typeof CKEditor>['editor'];

// The classic build ships looser types than the React wrapper expects.
export const ClassicEditor = ClassicEditorBuild as unknown as EditorProp;
